import React from 'react'
import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <footer className=" px-6 py-12 text-center border-t border-zinc-200">
        <div className="flex justify-center gap-8 mb-6">
          <Link
            to="/terms-of-service" 
            className="text-[10px] font-bold uppercase tracking-widest text-zinc-400 hover:text-[#ef3a5d] transition-colors"
          >
            Terms of Service
          </Link>
          <Link 
            to="/privacy-policy" 
            className="text-[10px] font-bold uppercase tracking-widest text-zinc-400 hover:text-[#ef3a5d] transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
        <div className="text-[10px] font-bold text-zinc-400 uppercase tracking-[0.5em]">
          Discownty © 2026 • Powering Restaurant Loyalty
        </div>
        <div style={{width:'100%',paddingTop:25,display:"flex",gap:10,alignItems:'center',justifyContent:'center'}}>
        <Link 
        to={'https://apps.apple.com/pk/app/discownty/id6757960111'}>
        <img src='/appstore.png' width={150} height={150}/>
        </Link>
        <Link 
        to={'https://play.google.com/store/apps/details?id=com.hammadrao.MyApp'}>
        <img src='/googleplay.png' width={150} height={150}/>
        </Link>
        </div>
      </footer>
  )
}
